
$(() => {
  const mouseEnter = function() {
    $(this).closest('.card').addClass('hover');
  }
  const mouseLeave = function() {
    $(this).closest('.card').removeClass('hover');
  }
  const focusEnter = function() {
    $(this).closest('.card').addClass('focus');
  }
  const focusLeave = function() {
    $(this).closest('.card').removeClass('focus');
  }
  $('.card.card-linked .card-title a')
    .on('mouseenter ', mouseEnter)
    .on('mousedown', function() {
        $(this).data('mousedown', true);
    })
    .on('mouseup', function() {
        $(this).removeData('mousedown');
    })
    .on('focus', function() {
      if (!$(this).data('mousedown')) {
        console.log('focusEnter');
        focusEnter.call(this);
      }
    })
    .on('mouseleave', mouseLeave)
    .on('blur', function() {
      $(this).removeData('mousedown');
      focusLeave.call(this);
    });
});
